import React from 'react';

export default class Timer extends React.Component {
  static defaultProps = {
    limit: 59
  };

  constructor(props) {
    super(props);

    this.state = {
      seconds: 0
    };
  }

  _tick() {
    if (this.props.limit > this.state.seconds) {
      this.setState({ seconds: this.state.seconds + 1 });
    } else {
      this.setState({ seconds: this.state.seconds });
    }
  }

  _leftPad(number, targetLength) {
    let output = `${number}`;
    while (output.length < targetLength) {
      output = `0${output}`;
    }
    return output;
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidMount() {
    this.interval = setInterval(() => this._tick(), 1000);
  }

  render() {
    const seconds = this._leftPad(this.state.seconds, 2);

    return (
      <span>
        0:{seconds}
        <style jsx>{`
          span {
            color: #9aa1ac;
          }
        `}</style>
      </span>
    );
  }
}
